import { render, staticRenderFns } from "./Installments.vue?vue&type=template&id=be94f4a4&"
import script from "./Installments.vue?vue&type=script&lang=js&"
export * from "./Installments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports